import { Skeleton } from "@chakra-ui/react"
import { ScopeLinkChip, SCOPE_CHIP_COLOURS } from "@hydrologiq/shared/components/ScopeLinkChip"
import { BaseDataConnectionCard } from "@hydrologiq/shared/data-connections/BaseDataConnectionCard"
import { AlignedTitles } from "@hydrologiq/shared/components/TitleWithChips"
import { ManagedByChip } from "@hydrologiq/shared/data-connections/ManagedByChip"
import { useSystemHeldConnections } from "../../hooks/useSystemHeldConnections"

interface SystemHeldConnectionsProps {
  systemId: string | undefined
  systemName: string | null | undefined
  /** The asset and, for a parent, its modules. */
  assetIds: string[]
}

/**
 * Connections the asset's system holds and maps to this asset, read-only:
 * they are switched on and mapped on the system.
 */
export function SystemHeldConnections({ systemId, systemName, assetIds }: SystemHeldConnectionsProps) {
  const { connections, loading } = useSystemHeldConnections(systemId, assetIds)

  if (!systemId) return null
  if (loading) return <Skeleton height="72px" width="100%" borderRadius="md" />
  if (connections.length === 0) return null

  return (
    // Every card's chips line up after the longest name
    <AlignedTitles display="flex" flexDirection="column" rowGap={3}>
      {connections.map((connection) => (
        <BaseDataConnectionCard
          key={connection.id}
          connection={connection}
          chips={
            <ScopeLinkChip
              label="System"
              href={`/systems/${systemId}/settings?tab=connections`}
              entityName={systemName || "System"}
              colours={SCOPE_CHIP_COLOURS.system}
            />
          }
          headerNote={<ManagedByChip scope="system" />}
        />
      ))}
    </AlignedTitles>
  )
}

export default SystemHeldConnections
